package com.github.jangalinski.tabweb._foundation.alignment

import com.varabyte.kobweb.compose.ui.Alignment

data object RIGHT : Horizontal, CardinalDirection {
  val alignment: Alignment.Horizontal = Alignment.End
}
